"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageDtoRoleEnum = void 0;
exports.instanceOfChatMessageDto = instanceOfChatMessageDto;
exports.ChatMessageDtoFromJSON = ChatMessageDtoFromJSON;
exports.ChatMessageDtoFromJSONTyped = ChatMessageDtoFromJSONTyped;
exports.ChatMessageDtoToJSON = ChatMessageDtoToJSON;
exports.ChatMessageDtoToJSONTyped = ChatMessageDtoToJSONTyped;
const ChatMessageDtoContent_1 = require("./ChatMessageDtoContent");
/**
 * @export
 */
exports.ChatMessageDtoRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
};
/**
 * Check if a given object implements the ChatMessageDto interface.
 */
function instanceOfChatMessageDto(value) {
    if (!('role' in value) || value['role'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
function ChatMessageDtoFromJSON(json) {
    return ChatMessageDtoFromJSONTyped(json, false);
}
function ChatMessageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'role': json['role'],
        'content': (0, ChatMessageDtoContent_1.ChatMessageDtoContentFromJSON)(json['content']),
    };
}
function ChatMessageDtoToJSON(json) {
    return ChatMessageDtoToJSONTyped(json, false);
}
function ChatMessageDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'role': value['role'],
        'content': (0, ChatMessageDtoContent_1.ChatMessageDtoContentToJSON)(value['content']),
    };
}
//# sourceMappingURL=ChatMessageDto.js.map